
// This format of value and label is used by the react-select component.

const permissionsOptions = [
  {
    value: '1',
    label: 'Administrator',
  }, {
    value: '2',
    label: 'Editor',
  }, {
    value: '3',
    label: 'Viewer',
  }, {
    value: '4',
    label: 'Deactivated',
  },
];

// Permissions checks: pass in a user

export const userIsAppAdmin = ({ roleId }) => (roleId === 5);
export const userIsAdmin = ({ roleId }) => (roleId === 1 || roleId === 5);
export const userCanEdit = ({ roleId }) => (roleId === 1 || roleId === 2 || roleId === 5);
export const userIsDeactivated = ({ roleId }) => (roleId === 4);

export default permissionsOptions;



// WEBPACK FOOTER //
// ./src/utils/permissionsOptions.js